import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getLevelsAsync, getRolesAsync, getTradesAsync } from 'src/redux/contentRedux/actions';

import { IRootState } from 'src/redux/rootReducer';

const ModalContainer: React.FC<Props> = ({
  isAuthenticated,

  getRoles,
  getTrades,
  getLevels,
}) => {
  useEffect(() => {
    if (isAuthenticated) {
      getRoles();
      getTrades();
      getLevels();
    }
    // eslint-disable-next-line
  }, [isAuthenticated]);
  return null;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IRootState) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

const mapDispatchToProps = {
  getRoles: getRolesAsync.request,
  getTrades: getTradesAsync.request,
  getLevels: getLevelsAsync.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
